const template119 = {
  logo: 'https://support.rizee.in/files/vignan_schools.jpeg',
  fallbackLetter: 'V',
  brandName: 'Vignan Junior College',
  brandTag: 'Group of Educational Institutions',
  schools: [
    { name: 'Vignan Junior College', area: 'Hyderabad' },
  ],
  stampSize: 320,
};

export default template119;
